import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("storeig_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve stored image paths to absolute URLs
export const imgUrl = (val) => {
  if (!val) return undefined;
  if (val.startsWith("http")) return val;
  if (val.startsWith("/api")) return `${BACKEND_URL}${val}`;
  return val;
};

export const money = (amount, currency = "eur") => {
  const symbol = currency === "eur" ? "€" : currency === "usd" ? "$" : "";
  return `${symbol}${Number(amount).toFixed(2)}`;
};

export const normalizeTiers = (tiers) =>
  (tiers || [])
    .map((t) => ({ min_qty: parseInt(t.min_qty, 10) || 0, price: t.price === "" || t.price == null ? NaN : parseFloat(t.price) }))
    .filter((t) => t.min_qty > 0 && !isNaN(t.price) && t.price >= 0)
    .sort((a, b) => a.min_qty - b.min_qty);

export const cartUnit = (item) =>
  item?.bundle ? Number(item.bundle.price) / item.bundle.min_qty : Number(item?.product?.price || 0);

export const cartLineTotal = (item) =>
  item?.bundle
    ? Number(item.bundle.price) * ((item.quantity || 0) / item.bundle.min_qty)
    : Number(item?.product?.price || 0) * (item?.quantity || 0);
